module.exports = __webpack_public_path__ + "static/media/instagramcontorno.dcec08ae.svg";